import type { ShipperRow } from "@services/drybulkCargoOperationsApi";
import {
  TOLERANCE_EDITABLE_OPERATION_STATUSES,
  WAITING_FINAL_DRAFT_SURVEY_STATUS,
} from "../constants";

export interface CloseOutActions {
  intermediate: "add" | "edit" | null;
  editTolerance: boolean;
  history: boolean;
}

export const closeOutActions = ({
  status,
  row,
  isShippingAgent,
  isOperations,
  held,
}: {
  status: string | null;
  row: Pick<ShipperRow, "tolerancePct">;
  isShippingAgent: boolean;
  isOperations: boolean;
  held: boolean;
}): CloseOutActions => {
  const hasTolerance = row.tolerancePct !== null && row.tolerancePct !== undefined;
  return {
    intermediate:
      isShippingAgent && status === WAITING_FINAL_DRAFT_SURVEY_STATUS
        ? held
          ? "edit"
          : "add"
        : null,
    editTolerance:
      isOperations && hasTolerance && TOLERANCE_EDITABLE_OPERATION_STATUSES.includes(status ?? ""),
    history: hasTolerance,
  };
};

export const hasCloseOutAction = (actions: CloseOutActions): boolean =>
  actions.intermediate !== null || actions.editTolerance || actions.history;
